export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20cozy%20hand%20drawn%20storybook%20illustration%20of%20a%20magical%20grocery%20store%20interior%20at%20dusk%2C%20glowing%20mysterious%20circular%20holes%20in%20the%20walls%2C%20warm%20amber%20lantern%20light%2C%20wooden%20shelves%20full%20of%20curious%20objects%2C%20cream%20and%20amber%20palette%2C%20fantasy%20cozy%20atmosphere%2C%20soft%20sparkles%20and%20shadows&width=1600&height=900&seq=home-hero-2026&orientation=landscape"
          alt="洞洞杂货铺漫画中温馨又神秘的杂货铺插画"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/55"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-5xl flex-col items-center px-4 py-24 md:px-6 md:py-36 text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs font-medium text-background-50 ring-1 ring-background-50/30 backdrop-blur-sm whitespace-nowrap">
          <i className="ri-sparkling-2-line"></i>
          洞洞杂货铺 · 设定与世界观完整解析
        </span>

        <h1 className="mt-7 font-heading text-4xl font-bold leading-tight text-background-50 md:text-6xl">
          洞洞杂货铺漫画
        </h1>
        <p className="mt-4 font-heading text-xl font-semibold text-secondary-200 md:text-2xl">
          从「洞洞含义」到「杂货铺设定」，一次读懂这部作品的完整世界观
        </p>
        <p className="mt-5 max-w-2xl text-sm leading-7 text-background-100/90 md:text-base">
          洞洞到底意味着什么？这家永远走不到尽头的杂货铺又藏着怎样的秘密？
          我们把这些散落在漫画里的伏笔、角色关系与故事背景整理成清晰的脉络，
          陪你一起揭开隐藏在角落里的线索。
        </p>

        <div className="mt-9 flex flex-col sm:flex-row items-center gap-3">
          <a
            href="/worldview"
            className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
          >
            开始读懂世界观
            <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="/settings"
            className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-6 py-3 text-sm font-medium text-background-50 ring-1 ring-background-50/40 backdrop-blur-sm transition-colors hover:bg-background-50/25 whitespace-nowrap"
          >
            查阅设定百科
          </a>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-6 md:gap-10">
          <div className="text-center">
            <p className="font-heading text-2xl font-bold text-background-50">3 大</p>
            <p className="mt-1 text-xs text-background-100/80">核心设定栏目</p>
          </div>
          <div className="h-8 w-px bg-background-50/30"></div>
          <div className="text-center">
            <p className="font-heading text-2xl font-bold text-background-50">12+</p>
            <p className="mt-1 text-xs text-background-100/80">篇深度解析文章</p>
          </div>
          <div className="h-8 w-px bg-background-50/30"></div>
          <div className="text-center">
            <p className="font-heading text-2xl font-bold text-background-50">6+</p>
            <p className="mt-1 text-xs text-background-100/80">位角色档案</p>
          </div>
        </div>
      </div>
    </section>
  );
}